class DictType {
    static STATIC = 0;
    static DYNAMIC = 1;
    static TREE = 2;
    static DYNAMICTREE = 3;
}

export default DictType;